import { useEffect, useRef } from 'react';

import { useNavigationContext } from '../context/NavigationContext';

export const useAutoExpand = (hasActiveChildren: boolean, isExpanded: boolean, itemText: string) => {
  const { isNavCollapsed, expandSection } = useNavigationContext();
  const prevIsNavCollapsed = useRef(isNavCollapsed);

  // Auto-expand when sidebar transitions from collapsed to expanded
  useEffect(() => {
    const wasCollapsed = prevIsNavCollapsed.current;
    const isNowExpanded = !isNavCollapsed;

    if (wasCollapsed && isNowExpanded && hasActiveChildren && !isExpanded) {
      expandSection(itemText);
    }

    prevIsNavCollapsed.current = isNavCollapsed;
  }, [isNavCollapsed, hasActiveChildren, isExpanded, itemText, expandSection]);

  useEffect(() => {
    if (hasActiveChildren && !isNavCollapsed) {
      expandSection(itemText);
    }
  }, [hasActiveChildren, isNavCollapsed, itemText, expandSection]);
};
